import ReactModal from "react-modal";
import React, { useRef, useEffect } from "react";
import cn from "classnames";

import styles from "./index.module.scss";

const ModalInner = ({
  active,
  onClose,
  children,
  theme = "black",
  scrollable = false,
  fullscreen = false,
  mobileCenter = false,
  overlayClassName,
  closeClassName = null,
  className,
}) => {
  const scrollElement = document.documentElement;
  const closeButtonRef = useRef();
  const modalContentRef = useRef();

  const preventClose = (e) => e.stopPropagation();

  useEffect(() => {
    scrollElement.style.overflow = "hidden";

    return () => {
      scrollElement.style.overflow = "auto";
    };
  }, []);

  return (
    <ReactModal
      isOpen={active}
      ariaHideApp={false}
      shouldCloseOnOverlayClick={false}
      onRequestClose={onClose}
      overlayClassName="react-modal-customized-modal-component-overlay"
      className="react-modal-customized-modal-component-content"
    >
      <div
        className={cn(styles.modalContentOverlay, overlayClassName)}
        onClick={onClose}
      />
      <div
        ref={modalContentRef}
        className={cn(
          styles.modalContent,
          className,
          theme === "white"
            ? styles.modalContentWhite
            : styles.modalContentBlack,
          {
            [styles.fullscreen]: fullscreen,
            [styles.scrollable]: scrollable,
            [styles.mobileCenter]: mobileCenter,
          }
        )}
        onClick={preventClose}
      >
        <span
          className={cn(styles.modalClose, "modalClose", closeClassName)}
          onClick={onClose}
          ref={closeButtonRef}
        />
        {children}
      </div>
    </ReactModal>
  );
};

// Use HOC here to prevent the body scrolling side effect
const Modal = (props) => {
  return props.active && <ModalInner {...props} />;
};

export default Modal;
